/* eslint-disable no-confusing-arrow */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/no-array-index-key */
/* eslint-disable max-len */
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Select, Checkbox, FormControl, InputLabel, ListItemText, MenuItem, OutlinedInput } from "@mui/material";
import ReactTooltip from "react-tooltip";
import SectionHeader from "../SectionHeader";
import SelectCustom from "../SelectCustom";
import Input from "../Input/Input";
import "./CycleDefinition.scss";
import {
  selectCartesianReadOnlyMode,
  selectDynamics,
  selectMechanics,
  setDynamics,
  setDynamicsSteps
} from "../../store/slices/cartesian";
import { DEFAULT_DYNAMICS, DIRECTIONS, MOVEMENT_TYPES } from "../../store/data/cartesianData";
import MsxIcons from "../../../Common/components/Icons/MsxIcons/MsxIcons";
import t from "../../../Common/utils/translation/translator";
import { newMaxMovements } from "../../utils/func.utils";

const CycleDefinition = ({ setSelectedMove, ...props }) => {
  const dispatch = useDispatch();
  const mechanics = useSelector(selectMechanics);
  const dynamics = useSelector(selectDynamics);
  const isReadOnlyMode = useSelector(selectCartesianReadOnlyMode);

  const EMPTY_CARRIAGE = {
    loads: [],
    forces: []
  };
  const [movementValidArray, setMovementValidArray] = useState([true, true, true]);
  const toggleMovementValidArray = (index, newValue) => {
    setMovementValidArray((prevArray) => {
      const newArray = [...prevArray];
      newArray[index] = newValue;
      return newArray;
    });
  };

  // variable to store the max movement for each step
  const [maxMovements, setMaxMovements] = useState(dynamics.steps.map(() => 0));
  const isEqual = (array1, array2) => JSON.stringify(array1) === JSON.stringify(array2);
  const parametersTypes = {
    mouvementAndAccelerationTime: t("cartesian.ui.dynamics.duration_of_movement_acceleration_and_deceleration"),
    positionAndAccelerationSpeed: t("cartesian.ui.dynamics.maximum_speed_acceleration_and_deceleration")
  };

  const [parametersType, setParametersType] = useState(parametersTypes.mouvementAndAccelerationTime);
  // on render, for each move add a an empty array for each carriage (depending on mechanics.quantityCarriages)
  // example : if we have 2 carriages then each move.carriages = [[], []]
  // except when it's already defined
  // note : if we have defined 3 carriages in move.carriages, then we should delete the last one
  // if we have only one we add one empty, etc
  useEffect(() => {
    const moves = [...dynamics.steps];
    const updatedMoves = moves.map((move) => {
      const newMove = { ...move };
      if (!newMove.carriages) {
        newMove.carriages = [];
      }
      if (newMove.carriages.length < mechanics.quantityCarriages) {
        for (let i = newMove.carriages.length; i < mechanics.quantityCarriages; i += 1) {
          newMove.carriages = [...newMove.carriages, EMPTY_CARRIAGE];
        }
      } else if (newMove.carriages.length > mechanics.quantityCarriages) {
        newMove.carriages = newMove.carriages.slice(0, mechanics.quantityCarriages);
      }
      return newMove;
    });
    if (!isReadOnlyMode) {
      setDynamicsSteps(updatedMoves);
    }
  }, [mechanics.quantityCarriages]);

  function defaultCarriagesLoadAndForces() {
    return Array.from({ length: mechanics.quantityCarriages }, () => ({
      loads: [...mechanics.loadsParameters.map((load) => load.id)],
      forces: [...mechanics.forcesParameters.map((force) => force.id)]
    }));
  }

  useEffect(() => {
    // This function will be called every time `moves` changes
    const newMaxMovementsValues = newMaxMovements(
      dynamics.steps,
      dynamics.startPosition,
      mechanics.strokeLength,
      DIRECTIONS
    );
    setMaxMovements(newMaxMovementsValues);
  }, [dynamics.steps, dynamics.startPosition, mechanics.strokeLength]);

  useEffect(() => {
    // for each move, calculate the parameters
    // this means that movement should already be defined
    // then we check the parametersType to know which parameters to calculate
    // if parametersType === mouvementAndAccelerationTime
    // then we should calculate the other parameters (peak, aacc, adcc)
    // conditions:
    // if movementType === dwell then peak, aacc and adcc should be empty strings
    // the tacc and tdec should be empty strings
    // the direction should be stop
    // if parametersType === positionAndAccelerationSpeed
    // then we should calculate the movement and acceleration time (tacc and tdec)
    // conditions:
    // if movementType === dwell then tacc and tdec should be empty strings
    // the peak, aacc and adcc should be empty strings
    // console.log("STARTING...");
    // console.log("MOVES", moves);
    let updatedMoves = [];
    if (dynamics.steps.length === 0) {
      updatedMoves = [
        {
          stepName: t("cartesian.ui.dynamics.step_n", { n: 1 }),
          movementType: MOVEMENT_TYPES.trapezoidal,
          movement: mechanics.strokeLength,
          direction: DIRECTIONS.forward,
          dwellTime: 0,
          travelTime: 2000,
          tacc: 500,
          sameTaccAndTdec: true,
          tdec: 500,
          peak: 0,
          aacc: 0,
          sameAaccAndAdcc: true,
          adcc: 0,
          carriages: defaultCarriagesLoadAndForces()
        },
        {
          stepName: t("cartesian.ui.dynamics.step_n", { n: 2 }),
          movementType: MOVEMENT_TYPES.trapezoidal,
          movement: mechanics.strokeLength,
          direction: DIRECTIONS.backward,
          dwellTime: 0,
          travelTime: 2000,
          tacc: 500,
          sameTaccAndTdec: true,
          tdec: 500,
          peak: 0,
          aacc: 0,
          sameAaccAndAdcc: true,
          adcc: 0,
          carriages: defaultCarriagesLoadAndForces()
        }
      ];
    } else {
      updatedMoves = dynamics.steps.map((move) => {
        const newMove = { ...move };
        if (newMove.movement) {
          if (parametersType === parametersTypes.mouvementAndAccelerationTime) {
            if (newMove.travelTime && newMove.tacc && newMove.tdec) {
              const { peak, aacc, adcc } = calculateParametersFromMovementAndAccelerationTime(
                newMove.movement,
                newMove.travelTime,
                newMove.tdec,
                newMove.tacc,
                newMove.sameTaccAndTdec
              );

              newMove.peak = peak;
              newMove.aacc = aacc;
              newMove.adcc = adcc;
            }
          } else if (parametersType === parametersTypes.positionAndAccelerationSpeed) {
            if (newMove.peak && newMove.aacc && newMove.adcc) {
              const { travelTime, tacc, tdec } = calculateParametersFromPositionAndAccelerationSpeed(
                newMove.movement,
                newMove.peak,
                newMove.aacc,
                newMove.adcc
              );

              newMove.travelTime = travelTime;
              newMove.tacc = tacc;
              newMove.tdec = tdec;
            }
          }
        }

        // console.log("NEW MOVE: ", newMove);
        return newMove;
      });

      // Calculate the final position
      const finalPositionWithoutCompletion = updatedMoves.reduce((sum, move) => {
        if (move.id === "completionStep") {
          return sum; // If the move is the completion step, skip it
        }
        return move.direction === DIRECTIONS.forward ? sum + move.movement : sum - move.movement;
      }, 0);

      // Calculate the final position with the completion step
      const finalPositionWithCompletion = updatedMoves.reduce(
        (sum, move) => (move.direction === DIRECTIONS.forward ? sum + move.movement : sum - move.movement),
        0
      );

      // If the final position is not 0, add a completion move
      if (finalPositionWithoutCompletion !== 0) {
        if (finalPositionWithCompletion !== 0) {
          const completionMove = {
            id: "completionStep",
            stepName: t("cartesian.ui.dynamics.cycle_completion"),
            movementType: MOVEMENT_TYPES.trapezoidal,
            movement: Math.abs(finalPositionWithoutCompletion), // movement that brings the final position to 0
            direction: finalPositionWithoutCompletion > 0 ? DIRECTIONS.backward : DIRECTIONS.forward, // direction that brings the final position to 0
            dwellTime: 0,
            travelTime: 1000,
            tacc: 100,
            sameTaccAndTdec: true,
            tdec: 100,
            peak: undefined,
            aacc: undefined,
            sameAaccAndAdcc: false,
            adcc: undefined,
            carriages: defaultCarriagesLoadAndForces()
          };
          if (parametersType === parametersTypes.mouvementAndAccelerationTime) {
            if (completionMove.travelTime && completionMove.tacc && completionMove.tdec) {
              const { peak, aacc, adcc } = calculateParametersFromMovementAndAccelerationTime(
                completionMove.movement,
                completionMove.travelTime,
                completionMove.tdec,
                completionMove.tacc,
                completionMove.sameTaccAndTdec
              );

              completionMove.peak = peak;
              completionMove.aacc = aacc;
              completionMove.adcc = adcc;
            }
          } else if (parametersType === parametersTypes.positionAndAccelerationSpeed) {
            if (completionMove.peak && completionMove.aacc && completionMove.adcc) {
              const { travelTime, tacc, tdec } = calculateParametersFromPositionAndAccelerationSpeed(
                completionMove.movement,
                completionMove.peak,
                completionMove.aacc,
                completionMove.adcc
              );

              completionMove.travelTime = travelTime;
              completionMove.tacc = tacc;
              completionMove.tdec = tdec;
            }
          }

          if (updatedMoves[updatedMoves.length - 1].id === "completionStep") {
            // If the last step is a completion step, update it
            updatedMoves[updatedMoves.length - 1] = completionMove;
          } else {
            // If the last step is not a completion step, add a new one
            updatedMoves.push(completionMove);
          }
        }
      } else if (updatedMoves[updatedMoves.length - 1].id === "completionStep") {
        // If the final position is 0 and the last step is a completion step, remove the completion step
        updatedMoves.pop();
      }
    }
    // Check if the updated moves are different from the existing ones before updating the state
    if (!isReadOnlyMode && !isEqual(updatedMoves, dynamics.steps)) {
      // console.log("UPDATING MOVES: ", moves, "=>", updatedMoves);
      dispatch(setDynamicsSteps(updatedMoves));
    }
  }, [dynamics, parametersType]);

  /* ---------- RULES ------------
  data in miliseconds :
  travel time is time acc + time dec + time const
  Travel time = (Movement - 1/2 * Peak * tacc/1000 * 1000 - 1/2 * Peak * tdec/1000 * 1000) / Peak + tacc + tdec
  tacc = Peak/aacc * 1000
  tdec = if sameTaccAndTdec then tacc else Peak/adcc * 1000

  data in mm :
  Mouvement = entred by user

  Peak (Max speed) = 2*Movement/(2*travelTime-tacc-tdec)
  aacc = Peak / tacc * 1000
  adcc = Peak / tdec * 1000

  if parametersType === mouvementAndAccelerationTime
  then we should calculate the other parameters
  else we should calculate the mouvement and acceleration time (tacc and tdec)

   */

  const calculateParametersFromMovementAndAccelerationTime = (movement, travelTime, tdec, tacc, sameTaccAndTdec) => {
    const peak = (2 * movement) / (2 * travelTime - tacc - tdec);
    const aacc = tacc !== 0 ? (peak / tacc) * 1000 : undefined;
    const adcc = sameTaccAndTdec || tdec === 0 ? aacc : (peak / tdec) * 1000;

    return {
      peak: peak?.toFixed(2),
      aacc: aacc?.toFixed(2),
      adcc: adcc?.toFixed(2)
    };
  };

  const calculateParametersFromPositionAndAccelerationSpeed = (movement, peak, aacc, adcc) => {
    const tacc = (peak / aacc) * 1000;
    const tdec = (peak / adcc) * 1000;

    // const travelTime = 1000;
    const travelTime =
      (movement - (((1 / 2) * peak * tacc) / 1000) * 1000 - (((1 / 2) * peak * tdec) / 1000) * 1000) / peak +
      tacc +
      tdec;

    return {
      travelTime: Math.trunc(travelTime),
      tacc: Math.trunc(tacc),
      tdec: Math.trunc(tdec)
    };
  };

  const updateParametersType = (newParametersType) => {
    setParametersType(newParametersType);
    // if (newParametersType === parametersTypes.mouvementAndAccelerationTime) {
    //   // for each move => unlink aacc and adcc
    //   setMoves(moves.map((move) => ({ ...move, sameAaccAndAdcc: false })));
    // }
    // if (newParametersType === parametersTypes.positionAndAccelerationSpeed) {
    //   // for each move => unlink tacc and tdec
    //   setMoves(moves.map((move) => ({ ...move, sameTaccAndTdec: false })));
    // }
  };

  const updateStepName = (index, newStepName) => {
    const newMoves = [...dynamics.steps];
    const updatedMove = { ...newMoves[index], stepName: newStepName };
    newMoves[index] = updatedMove;
    // console.log("UPDATING STEP NAME: ", newMoves);
    dispatch(setDynamicsSteps(newMoves));
  };

  const updateMovementType = (index, newMovementType) => {
    const newMoves = [...dynamics.steps];
    const updatedMove = { ...newMoves[index], movementType: newMovementType };
    newMoves[index] = updatedMove;
    dispatch(setDynamicsSteps(newMoves));
  };

  const updateMovement = (index, newMovement, direction) => {
    const newMoves = [...dynamics.steps];
    const updatedMove = {
      ...newMoves[index],
      movement: newMovement === "" ? "" : Number(newMovement)
    };
    newMoves[index] = updatedMove;
    dispatch(setDynamicsSteps(newMoves));
  };

  const correctNumberFormat = (number) => {
    // match empty string or a number with up to 2 decimal places
    const regex = /^$|^-?\d+(\.\d{1,2})?$/;
    if (!regex.test(number)) {
      return false;
    }
    return true;
  };

  const updateDirection = (index, newDirection) => {
    const newMoves = JSON.parse(JSON.stringify([...dynamics.steps]));
    const updatedMove = { ...newMoves[index], direction: newDirection };
    newMoves[index] = updatedMove;

    // Update the direction of the other step based on the direction of the current step
    // if (index === 0) {
    //   newMoves[1].direction = newDirection === DIRECTIONS.forward ? DIRECTIONS.backward : DIRECTIONS.forward;
    // } else if (index === 1) {
    //   newMoves[0].direction = newDirection === DIRECTIONS.forward ? DIRECTIONS.backward : DIRECTIONS.forward;
    // }

    dispatch(setDynamicsSteps(newMoves));
  };

  const updateDwellTime = (index, newDwellTime) => {
    const newMoves = [...dynamics.steps];
    const updatedMove = { ...newMoves[index], dwellTime: parseFloat(newDwellTime) };
    newMoves[index] = updatedMove;
    dispatch(setDynamicsSteps(newMoves));
  };

  const updateTravelTime = (index, newTravelTime) => {
    // deny the user to enter a float number
    if (newTravelTime.includes(".") || newTravelTime.includes(",")) {
      return;
    }
    const newMoves = [...dynamics.steps];
    const updatedMove = { ...newMoves[index], travelTime: parseInt(newTravelTime) };
    newMoves[index] = updatedMove;
    dispatch(setDynamicsSteps(newMoves));
  };

  const updateTacc = (index, newTacc) => {
    const newMoves = [...dynamics.steps];
    const { sameTaccAndTdec } = newMoves[index];
    const updatedMove = { ...newMoves[index], tacc: parseInt(newTacc) };
    if (sameTaccAndTdec) {
      updatedMove.tdec = parseInt(newTacc);
    }
    newMoves[index] = updatedMove;
    dispatch(setDynamicsSteps(newMoves));
  };

  const updateSameTaccAndTdec = (index, newSameTaccAndTdec) => {
    // console.log("updateSameTaccAndTdec");
    const newMoves = [...dynamics.steps];
    const updatedMove = {
      ...newMoves[index],
      sameTaccAndTdec: newSameTaccAndTdec,
      sameAaccAndAdcc: newSameTaccAndTdec
    };
    if (newSameTaccAndTdec) {
      updatedMove.tdec = updatedMove.tacc;
    }
    newMoves[index] = updatedMove;
    dispatch(setDynamicsSteps(newMoves));
  };

  const updateTdec = (index, newTdec) => {
    const newMoves = [...dynamics.steps];
    const updatedMove = { ...newMoves[index], tdec: parseInt(newTdec) };
    newMoves[index] = updatedMove;
    dispatch(setDynamicsSteps(newMoves));
  };

  const updatePeak = (index, newPeak) => {
    if (!correctNumberFormat(newPeak)) {
      return;
    }
    const newMoves = [...dynamics.steps];
    const updatedMove = { ...newMoves[index], peak: parseFloat(newPeak) };
    newMoves[index] = updatedMove;
    dispatch(setDynamicsSteps(newMoves));
  };

  const updateAacc = (index, newAacc) => {
    if (!correctNumberFormat(newAacc)) {
      return;
    }
    const newMoves = [...dynamics.steps];
    const { movement, peak, adcc, sameAaccAndAdcc } = newMoves[index];
    const newAdcc = sameAaccAndAdcc ? newAacc : adcc;
    const updatedMove = { ...newMoves[index], aacc: parseFloat(newAacc), adcc: parseFloat(newAdcc) };
    const { travelTime, tacc, tdec } = calculateParametersFromPositionAndAccelerationSpeed(
      movement,
      peak,
      newAacc,
      adcc
    );
    updatedMove.travelTime = travelTime;
    updatedMove.tacc = tacc;
    updatedMove.tdec = tdec;
    newMoves[index] = updatedMove;
    dispatch(setDynamicsSteps(newMoves));
  };

  const updateSameAaccAndAdcc = (index, newSameAaccAndAdcc) => {
    // console.log("updateSameAaccAndAdcc");
    const newMoves = [...dynamics.steps];
    const updatedMove = {
      ...newMoves[index],
      sameAaccAndAdcc: newSameAaccAndAdcc,
      sameTaccAndTdec: newSameAaccAndAdcc
    };
    if (newSameAaccAndAdcc) {
      updatedMove.adcc = updatedMove.aacc;
    }
    newMoves[index] = updatedMove;
    dispatch(setDynamicsSteps(newMoves));
  };

  const updateAdcc = (index, newAdcc) => {
    if (!correctNumberFormat(newAdcc)) {
      return;
    }
    const newMoves = [...dynamics.steps];
    const { movement, peak, aacc } = newMoves[index];
    const updatedMove = { ...newMoves[index], adcc: parseFloat(newAdcc) };
    const { travelTime, tacc, tdec } = calculateParametersFromPositionAndAccelerationSpeed(
      movement,
      peak,
      aacc,
      newAdcc
    );
    updatedMove.travelTime = travelTime;
    updatedMove.tacc = tacc;
    updatedMove.tdec = tdec;
    newMoves[index] = updatedMove;
    dispatch(setDynamicsSteps(newMoves));
  };

  // const handleDeleteStep = (index) => {
  //   const newMoves = [...moves];
  //   newMoves.splice(index, 1);
  //   setMoves(newMoves);
  // };

  // const handleDuplicateStep = (index) => {
  //   const newMoves = [...moves];
  //   newMoves.splice(index, 0, { ...newMoves[index] });
  //   setMoves(newMoves);
  // };

  const generateHeaderCSSClasses = (headerName) => {
    /* if parameterType === mouvementAndAccelerationTime
    then the color of Travel time, tacc and tdec and "linkTaccAndTdec" should be secondary
    and the bottom border should be secondary.
    if parameterType === positionAndAccelerationSpeed
    then the color of Peak, aacc and adcc should be secondary
    and the bottom border should be secondary.
    */

    if (parametersType === parametersTypes.mouvementAndAccelerationTime) {
      if (
        headerName === "Travel time" ||
        headerName === "Acc. time" ||
        headerName === "linkTaccAndTdec" ||
        headerName === "Dec. time"
      ) {
        return "text-secondary border-b-2 border-secondary border-solid";
      }
    } else if (parametersType === parametersTypes.positionAndAccelerationSpeed) {
      if (
        headerName === "Maximal speed" ||
        headerName === "Peak Acc" ||
        headerName === "linkAaccAndAdcc" ||
        headerName === "Peak Dec"
      ) {
        return "text-secondary border-b-2 border-secondary border-solid";
      }
    }
    return "";
  };

  const generateHeader = (headers) => (
    <thead className="bg-white py-2 border-b border-primary border-solid">
      <tr>
        {headers.map((header, index) => (
          <th
            className={`font-normal whitespace-nowrap text-gray-500 min-w-[10px]
            ${generateHeaderCSSClasses(header)}`}
            key={index}
          >
            {header === "linkAaccAndAdcc" || header === "linkTaccAndTdec" ? "" : header}
          </th>
        ))}
      </tr>
    </thead>
  );

  const selectStyles = {
    borderRadius: "0",
    fontSize: "12px",
    margin: 0
  };

  const handleSetLoads = (event, idx, carriageIndex) => {
    // console.log("handleSetLoads", event, idx, carriageIndex);
    const {
      target: { value }
    } = event;
    const newMoves = [...dynamics.steps];
    // we push the value inside the move[idx].carriages[carriageIndex].loads
    const newLoadIds = value.map((loadTitle) => mechanics.loadsParameters.find((l) => l.title === loadTitle)?.id);
    const newCarriages = [...newMoves[idx].carriages];
    newCarriages[carriageIndex] = {
      ...newCarriages[carriageIndex],
      loads: newLoadIds
    };
    newMoves[idx] = { ...newMoves[idx], carriages: newCarriages };
    dispatch(setDynamicsSteps(newMoves));
  };

  const handleSetForces = (event, idx, carriageIndex) => {
    // console.log("handleSetForces", event, idx, carriageIndex);
    const {
      target: { value }
    } = event;
    const newMoves = [...dynamics.steps];
    // we push the value inside the move[idx].carriages[carriageIndex].forces
    const newForceIds = value.map((forceTitle) => mechanics.forcesParameters.find((f) => f.title === forceTitle)?.id);
    const newCarriages = [...newMoves[idx].carriages];
    newCarriages[carriageIndex] = {
      ...newCarriages[carriageIndex],
      forces: newForceIds
    };
    newMoves[idx] = { ...newMoves[idx], carriages: newCarriages };
    dispatch(setDynamicsSteps(newMoves));
  };

  const updateStartPosition = (value) => {
    // if the value is not a number or "" then return
    if (isNaN(value) && value !== "") {
      return;
    }
    // startPosition should be between 0 and strokeLength
    // if (value < 0 || value > mechanics.strokeLength) {
    //   // eslint-disable-next-line no-alert
    //   alert(
    //     `The start position should be between 0 and ${mechanics.strokeLength}mm`
    //   );
    //   return;
    // }
    dispatch(setDynamics({ ...dynamics, startPosition: value === "" ? "" : Number(value) }));
  };

  const handleResetMoves = () => {
    dispatch(setDynamics(DEFAULT_DYNAMICS));
    dispatch(
      setDynamicsSteps([...DEFAULT_DYNAMICS.steps.map((step) => ({ ...step, movement: mechanics.strokeLength }))])
    );
    setSelectedMove(null);
    setParametersType(parametersTypes.mouvementAndAccelerationTime);
  };
  // MSC-1243
  // testing purpose
  // const fillFakeData = () => {
  //   dispatch(setDynamics(TESTING_DYNAMICS_DATA));
  //   setMoves([...TESTING_DYNAMICS_DATA.steps]);
  // };

  const handleAddNewMove = () => {
    // console.log("handleAddNewMove");
    const completionStepIndex = dynamics.steps.findIndex((move) => move.id === "completionStep");
    let newMove = null;
    if (completionStepIndex !== -1) {
      // If there is a completion step, add the new move before it
      dispatch(
        setDynamicsSteps([
          ...dynamics.steps.slice(0, completionStepIndex),
          {
            ...dynamics.steps[dynamics.steps.length - 2],
            stepName: t("cartesian.ui.dynamics.step_n", { n: dynamics.steps.length }),
            direction:
              dynamics.steps[dynamics.steps.length - 2].direction === DIRECTIONS.forward
                ? DIRECTIONS.backward
                : DIRECTIONS.forward
          },
          ...dynamics.steps.slice(completionStepIndex)
        ])
      );
    } else {
      dispatch(
        setDynamicsSteps([
          ...dynamics.steps,
          {
            ...dynamics.steps[dynamics.steps.length - 1],
            stepName: t("cartesian.ui.dynamics.step_n", { n: dynamics.steps.length + 1 }),
            direction:
              dynamics.steps[dynamics.steps.length - 1].direction === DIRECTIONS.forward
                ? DIRECTIONS.backward
                : DIRECTIONS.forward
          }
        ])
      );
    }
    setSelectedMove(newMove);
  };

  const handleOnSelectMovement = (index) => {
    if (dynamics.strokeLength !== undefined && dynamics.strokeLength !== mechanics.strokeLength) {
      toggleMovementValidArray(index, false);
      updateMovementValidity(index, true);
    }
  };

  const updateMovementValidity = (index, valid) => {
    const newMoves = [...dynamics.steps];
    const updatedMove = {
      ...newMoves[index],
      isValid: valid
    };
    newMoves[index] = updatedMove;
    dispatch(setDynamicsSteps(newMoves));
  };

  const handleMovementInvalidity = (move, index) => {
    // move.movement === 0 || move.movement === "" || move.movement > maxMovements[index]
    //const isInvalid = move.movement === 0 || move.movement === "" || move.movement > maxMovements[index];
    const isInvalid =
      move.movement === 0 ||
      move.movement === "" ||
      move.movement > maxMovements[index] ||
      (move?.id !== "completionStep" &&
        movementValidArray[index] &&
        dynamics.strokeLength !== undefined &&
        dynamics.strokeLength !== mechanics.strokeLength);
    return isInvalid;
  };

  const handleMovementError = (move, index) => {
    let errorMsg =
      move.movement === "" || move.movement === 0
        ? t("cartesian.ui.dynamics.entering_a_movement_is_mandatory")
        : t("cartesian.ui.dynamics.maximum_movement-firstpart") +
          " " +
          maxMovements[index] +
          t("cartesian.ui.dynamics.maximum_movement-secondpart");

    if (
      move?.id !== "completionStep" &&
      movementValidArray[index] &&
      dynamics.strokeLength !== undefined &&
      dynamics.strokeLength !== mechanics.strokeLength
    ) {
      errorMsg = t("cartesian.ui.dynamics.stroke_length_mismatch");
      //updateMovementValidity(index, false);
    }

    return errorMsg;
  };

  /* dynamics.steps.forEach((move, index) => {
    if (
      move?.id !== "completionStep" &&
      movementValidArray[index] &&
      dynamics.strokeLength !== undefined &&
      dynamics.strokeLength !== mechanics.strokeLength
    ) {
      updateMovementValidity(index, false);
    }
  }); */

  return (
    <>
      <div className="CycleDefinition" id="cycle-definition" {...props}>
        <SectionHeader data-testid="section-header" title={t("cartesian.ui.dynamics.cycle_definition")} />
        <div className="text-xs p-2 bg-gray-10 flex flex-col space-y-3">
          {/* HEADER */}
          <div className="flex justify-between">
            <div className="flex items-center space-x-2">
              <span>{t("cartesian.ui.dynamics.start_position")}</span>
              <Input
                data-testid="input-startPosition"
                value={dynamics.startPosition}
                // type="number"
                // min="0"
                unit="mm"
                onChange={(e) => updateStartPosition(e.target.value)}
                style={{ width: "100px" }}
                invalid={dynamics.startPosition < 0 || dynamics.startPosition > mechanics.strokeLength}
                invalidText={`The start position should be between 0 and ${mechanics.strokeLength}mm`}
              />
            </div>
            <div className="flex space-x-2">
              <qds-button
                data-testid="button-reset-all"
                size="small"
                text={t("cartesian.ui.dynamics.reset_all")}
                onClick={() => {
                  handleResetMoves();
                }}
                icon-name="arrows-loop"
              >
                <MsxIcons className="trasfom scale-90" name="refresh" />
              </qds-button>
              {/*MSC-1243 <qds-button
                size="small"
                onClick={() => {
                  fillFakeData();
                }}
                text={t("cartesian.ui.dynamics.fill_with_testing_data")}
              ></qds-button> */}
            </div>
          </div>
          {/* ENDHEADER */}
          {/* TABLE */}
          <div className="flex space-x-2 text-xs overflow-x-auto thin-scroll-bar">
            <div className="text-center">
              <table className="w-full mt-16">
                {generateHeader([
                  "",
                  t("cartesian.ui.dynamics.step_name"),
                  t("cartesian.ui.dynamics.movement_type"),
                  t("cartesian.ui.dynamics.movement"),
                  t("cartesian.ui.dynamics.direction"),
                  t("cartesian.ui.dynamics.dwell_time")
                ])}
                <tbody>
                  {dynamics.steps.map((move, index) => (
                    <tr key={index}>
                      <td>
                        <qds-button
                          data-testid={`button-trash-${index}`}
                          size="small"
                          icon-name="trash-can"
                          importance="subdued"
                          {...(dynamics.steps.length <= 2 ? { disabled: "" } : {})}
                          onClick={() => {
                            const newMoves = [...dynamics.steps];
                            newMoves.splice(index, 1);
                            dispatch(setDynamicsSteps(newMoves));
                            setSelectedMove(null);
                          }}
                        />
                      </td>
                      <td>
                        <Input
                          data-testid={`input-stepName-${index}`}
                          value={move.stepName}
                          onChange={(e) => updateStepName(index, e.target.value)}
                          style={{ width: "100px" }}
                          mandatory="true"
                          invalid={move.stepName === ""}
                          invalidText={t("cartesian.ui.dynamics.entering_a_step_name_is_mandatory")}
                        />
                      </td>
                      <td>
                        <SelectCustom
                          data-testid={`select-movementType-${index}`}
                          options={Object.values(MOVEMENT_TYPES).map((type) => ({
                            value: type,
                            label: type
                          }))}
                          value={move.movementType}
                          onChange={(e) => {
                            updateMovementType(index, e.target.value);
                          }}
                        />
                      </td>
                      <td>
                        <Input
                          data-testid={`input-movement-${index}`}
                          value={move.movement}
                          type="number"
                          min="1"
                          unit="mm"
                          onChange={(e) => updateMovement(index, e.target.value, move.direction)}
                          onSelect={(e) => handleOnSelectMovement(index)}
                          disabled={move.id === "completionStep"}
                          invalid={handleMovementInvalidity(move, index)}
                          invalidText={handleMovementError(move, index)}
                        />
                      </td>
                      <td>
                        <SelectCustom
                          data-testid={`select-direction-${index}`}
                          options={Object.values(DIRECTIONS).map((directionKey) => ({
                            value: directionKey,
                            label: directionKey
                          }))}
                          value={move.direction}
                          onChange={(e) => updateDirection(index, e.target.value)}
                          disabled={move.id === "completionStep"}
                        />
                      </td>
                      <td>
                        <Input
                          data-testid={`input-dwellTime-${index}`}
                          value={move.dwellTime}
                          type="number"
                          min="0"
                          unit="ms"
                          onChange={(e) => updateDwellTime(index, e.target.value)}
                          invalid={move.dwellTime === "" || move.dwellTime < 0}
                          invalidText={t("msizer.ui.mandatory_field")}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="">
              <div className="w-full border-t-2 border-primary border-solid bg-white p-2 shadow h-16 flex items-center">
                <div className="flex flex-col space-y-2 w-full">
                  <div className=" w-full">{t("cartesian.ui.dynamics.select_the_parameters_to_define")}</div>
                  <div className="flex">
                    {/* radio button with 2 options, each one takes 50% of the width */}
                    <div className="flex-1 space-x-1 flex items-center">
                      <input
                        data-testid="input-mouvementAndAccelerationTime"
                        type="radio"
                        name="parametersType"
                        value={parametersTypes.mouvementAndAccelerationTime}
                        id={parametersTypes.mouvementAndAccelerationTime}
                        checked={parametersType === parametersTypes.mouvementAndAccelerationTime}
                        onChange={(e) => {
                          updateParametersType(e.target.value);
                        }}
                      />
                      <label htmlFor={parametersTypes.mouvementAndAccelerationTime}>
                        {parametersTypes.mouvementAndAccelerationTime}
                      </label>
                    </div>
                    <div className="flex-1 space-x-1 flex items-center">
                      <input
                        data-testid="input-positionAndAccelerationSpeed"
                        type="radio"
                        name="parametersType"
                        value={parametersTypes.positionAndAccelerationSpeed}
                        id={parametersTypes.positionAndAccelerationSpeed}
                        checked={parametersType === parametersTypes.positionAndAccelerationSpeed}
                        onChange={(e) => {
                          updateParametersType(e.target.value);
                        }}
                        className="ml-8"
                      />
                      <label htmlFor={parametersTypes.positionAndAccelerationSpeed}>
                        {parametersTypes.positionAndAccelerationSpeed}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <table className="w-full">
                {generateHeader([
                  t("cartesian.ui.dynamics.travel_time"),
                  t("cartesian.ui.dynamics.acc_time"),
                  t("cartesian.ui.dynamics.linkTaccAndTdec"),
                  t("cartesian.ui.dynamics.dec_time"),
                  "_",
                  t("cartesian.ui.dynamics.maximal_speed"),
                  t("cartesian.ui.dynamics.peak_acc"),
                  t("cartesian.ui.dynamics.linkAaccAndAdcc"),
                  t("cartesian.ui.dynamics.peak_dec")
                ])}
                <tbody>
                  {dynamics.steps.map((move, index) => (
                    <tr key={index}>
                      <td>
                        <Input
                          data-testid={`input-travelTime-${index}`}
                          value={move.travelTime}
                          type="number"
                          onChange={(e) => {
                            updateTravelTime(index, e.target.value);
                          }}
                          disabled={parametersType !== parametersTypes.mouvementAndAccelerationTime}
                          unit="ms"
                          invalid={
                            Number(move.travelTime) % 1 !== 0 ||
                            Number(move.travelTime) < Number(move.tacc) + Number(move.tdec)
                          }
                          invalidText={t("cartesian.ui.dynamics.travel_time_invalid")}
                        />
                      </td>
                      <td>
                        <Input
                          data-testid={`input-tacc-${index}`}
                          value={move.tacc}
                          type="number"
                          onChange={(e) => updateTacc(index, e.target.value)}
                          disabled={parametersType !== parametersTypes.mouvementAndAccelerationTime}
                          unit="ms"
                          invalid={
                            Number(move.tacc) % 1 !== 0 ||
                            Number(move.travelTime) < Number(move.tacc) + Number(move.tdec)
                          }
                          invalidText={t("cartesian.ui.dynamics.travel_time_invalid")}
                        />
                      </td>
                      <td>
                        <div className="cursor-pointer w-5 text-center">
                          {move.sameTaccAndTdec ? (
                            <span
                              className="cursor-pointer"
                              onClick={() => {
                                updateSameTaccAndTdec(index, false);
                              }}
                            >
                              <MsxIcons name="link" size="small" className="transform scale-90 text-secondary" />
                            </span>
                          ) : (
                            <div
                              data-tip
                              data-for={`linkTaccAndTdec${index}`}
                              className="cursor-pointer flex"
                              tabIndex={-1}
                            >
                              <span
                                className="cursor-pointer"
                                onClick={() => {
                                  updateSameTaccAndTdec(index, true);
                                }}
                              >
                                <MsxIcons name="unlink" size="small" className="transform scale-90 text-gray-400" />
                              </span>
                              <ReactTooltip
                                id={`linkTaccAndTdec${index}`}
                                place="right"
                                effect="solid"
                                backgroundColor="#FFFFFF"
                                textColor="rgb(31 41 55)"
                                className="shadow-[0px_0px_8px_rgba(98,100,105,0.5)] rounded-[10px]"
                              >
                                <div>Click here to set the same value for both parameters</div>
                              </ReactTooltip>
                            </div>
                          )}
                        </div>
                      </td>
                      <td>
                        <Input
                          data-testid={`input-tdec-${index}`}
                          value={move.tdec}
                          type="number"
                          onChange={(e) => updateTdec(index, e.target.value)}
                          disabled={
                            parametersType !== parametersTypes.mouvementAndAccelerationTime || move.sameTaccAndTdec
                          }
                          unit="ms"
                          invalid={
                            Number(move.tdec) % 1 !== 0 ||
                            Number(move.travelTime) < Number(move.tacc) + Number(move.tdec)
                          }
                          invalidText={t("cartesian.ui.dynamics.travel_time_invalid")}
                        />
                      </td>
                      <td>
                        <div className="w-5" />
                      </td>
                      <td>
                        <Input
                          data-testid={`input-peak-${index}`}
                          value={move.peak}
                          type="number"
                          step={0.01}
                          min={0}
                          onChange={(e) => updatePeak(index, e.target.value)}
                          disabled={parametersType !== parametersTypes.positionAndAccelerationSpeed}
                          unit="m/s"
                          invalid={Number(move.travelTime) < Number(move.tacc) + Number(move.tdec)}
                          invalidText={t("cartesian.ui.dynamics.travel_time_invalid")}
                        />
                      </td>
                      <td>
                        <Input
                          data-testid={`input-aacc-${index}`}
                          value={move.aacc}
                          type="number"
                          step={0.01}
                          min={0}
                          onChange={(e) => updateAacc(index, e.target.value)}
                          disabled={parametersType !== parametersTypes.positionAndAccelerationSpeed}
                          unit="m/s²"
                          invalid={Number(move.travelTime) < Number(move.tacc) + Number(move.tdec)}
                          invalidText={t("cartesian.ui.dynamics.travel_time_invalid")}
                        />
                      </td>
                      <td>
                        <div className="cursor-pointer w-5 text-center">
                          {move.sameAaccAndAdcc ? (
                            <span
                              className="cursor-pointer"
                              onClick={() => {
                                updateSameAaccAndAdcc(index, false);
                              }}
                            >
                              <MsxIcons name="link" size="small" className="transform scale-90 text-secondary" />
                            </span>
                          ) : (
                            <div
                              data-tip
                              data-for={`linkTaccAndTdec${index}`}
                              className="cursor-pointer flex"
                              tabIndex={-1}
                            >
                              <span
                                className="cursor-pointer"
                                onClick={() => {
                                  updateSameAaccAndAdcc(index, true);
                                }}
                              >
                                <MsxIcons name="unlink" size="small" className="transform scale-90 text-gray-400" />
                              </span>
                              <ReactTooltip
                                id={`linkAaccAndAdcc${index}`}
                                place="right"
                                effect="solid"
                                backgroundColor="#FFFFFF"
                                textColor="rgb(31 41 55)"
                                className="shadow-[0px_0px_8px_rgba(98,100,105,0.5)] rounded-[10px]"
                              >
                                <div>Click here to set the same value for both parameters</div>
                              </ReactTooltip>
                            </div>
                          )}
                        </div>
                      </td>
                      <td>
                        <Input
                          data-testid={`input-adcc-${index}`}
                          value={move.adcc}
                          type="number"
                          step={0.01}
                          min={0}
                          onChange={(e) => updateAdcc(index, e.target.value)}
                          disabled={
                            parametersType !== parametersTypes.positionAndAccelerationSpeed || move.sameAaccAndAdcc
                          }
                          unit="m/s²"
                          invalid={Number(move.travelTime) < Number(move.tacc) + Number(move.tdec)}
                          invalidText={t("cartesian.ui.dynamics.travel_time_invalid")}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {Array.from({ length: mechanics.quantityCarriages }, (_, carriageIndex) => (
              <div>
                <div className="w-full border-t-2 border-primary border-solid bg-white p-2 shadow h-16 flex items-center">
                  <div className="flex flex-col space-y-2 w-full text-center">
                    <div className=" w-full">{t("cartesian.ui.dynamics.carriage_n", { n: carriageIndex + 1 })}</div>
                  </div>
                </div>
                <table>
                  {generateHeader([t("cartesian.ui.dynamics.loads"), t("cartesian.ui.dynamics.Forces")])}
                  <tbody>
                    {dynamics.steps.map((move, idx) => (
                      <tr key={idx}>
                        <td>
                          {/* <Select
                      defaultValue={[]}
                      isMulti
                      name="loads"
                      options={Object.values(mechanics.loadsParameters)
                        .filter((load) => load.enable)
                        .map((elt) => ({
                          value: elt.title,
                          label: elt.title
                        }))}
                      className="w-32"
                      classNamePrefix="select"
                    /> */}
                          <FormControl sx={{ m: 0, width: 200 }} size="small">
                            <InputLabel
                              id="demo-multiple-checkbox-label"
                              // shrink={false}
                              style={{ fontSize: "12px" }}
                            >
                              {t("cartesian.ui.dynamics.loads")}
                            </InputLabel>
                            <Select
                              style={selectStyles}
                              sx={{
                                "& .MuiSelect-select": {
                                  padding: "4.5px 16px",
                                  "&:focus": {
                                    borderColor: "#42B4E6"
                                  }
                                }
                              }}
                              labelId="loads"
                              id="loads"
                              multiple
                              value={
                                move.carriages[carriageIndex]?.loads.map(
                                  (loadId) => mechanics.loadsParameters.find((load) => load.id === loadId)?.title
                                ) || []
                              }
                              onChange={(e) => handleSetLoads(e, idx, carriageIndex)}
                              input={<OutlinedInput label={t("cartesian.ui.dynamics.loads")} />}
                              renderValue={(selected) => selected.join(", ")}
                            >
                              {Object.values(mechanics.loadsParameters).map((elt) => {
                                return (
                                  <MenuItem
                                    key={elt.id}
                                    value={elt.title}
                                    sx={{
                                      "&.Mui-selected": {
                                        backgroundColor: "#008a1610"
                                      },
                                      "&:hover": {
                                        backgroundColor: "#008a1620"
                                      },
                                      "&.Mui-selected:hover": {
                                        backgroundColor: "#008a1620"
                                      },
                                      py: 0,
                                      px: 1
                                    }}
                                  >
                                    <Checkbox
                                      checked={move.carriages[carriageIndex]?.loads?.includes(elt.id) ?? null}
                                      style={{ color: "#008a16" }}
                                    />
                                    <ListItemText primary={elt.title} />
                                  </MenuItem>
                                );
                              })}
                            </Select>
                          </FormControl>
                        </td>
                        <td>
                          {/* <SelectCustom
                      options={Object.values(
                        mechanics.forcesParameters
                          .filter((force) => force.enable)
                          .map((elt) => ({
                            value: elt.title,
                            label: elt.title
                          }))
                      )}
                      value=""
                      onChange={() => {}}
                    /> */}
                          {/* <Select
                      defaultValue={[]}
                      isMulti
                      name="Forces"
                      options={Object.values(
                        mechanics.forcesParameters
                          .filter((force) => force.enable)
                          .map((elt) => ({
                            value: elt.title,
                            label: elt.title
                          }))
                      )}
                      className=""
                      classNamePrefix="select"
                    /> */}
                          <FormControl sx={{ m: 0, width: 200 }} size="small">
                            <InputLabel
                              id="demo-multiple-checkbox-label"
                              // shrink={false}
                              style={{ fontSize: "12px" }}
                            >
                              {t("cartesian.ui.dynamics.Forces")}
                            </InputLabel>

                            <Select
                              data-testid="select-forces"
                              style={selectStyles}
                              sx={{
                                "& .MuiSelect-select": {
                                  padding: "4.5px 16px",
                                  "&:focus": {
                                    borderColor: "#42B4E6"
                                  }
                                }
                              }}
                              labelId="forces"
                              id="forces"
                              multiple
                              value={
                                move.carriages[carriageIndex]?.forces.map(
                                  (forceId) => mechanics.forcesParameters.find((force) => force.id === forceId)?.title
                                ) || []
                              }
                              onChange={(e) => handleSetForces(e, idx, carriageIndex)}
                              input={<OutlinedInput label={t("cartesian.ui.dynamics.Forces")} />}
                              renderValue={(selected) => selected.join(", ")}
                            >
                              {Object.values(mechanics.forcesParameters).map((elt) => (
                                <MenuItem
                                  key={elt.id}
                                  value={elt.title}
                                  sx={{
                                    "&.Mui-selected": {
                                      backgroundColor: "#008a1610"
                                    },
                                    "&:hover": {
                                      backgroundColor: "#008a1620"
                                    },
                                    "&.Mui-selected:hover": {
                                      backgroundColor: "#008a1620"
                                    },
                                    py: 0,
                                    px: 1
                                  }}
                                >
                                  <Checkbox
                                    checked={move.carriages[carriageIndex]?.forces?.includes(elt.id) ?? null}
                                    style={{ color: "#008a16" }}
                                  />
                                  <ListItemText primary={elt.title} />
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ))}
            {/* add delete buttons for each row */}
            {/* <div>
      <div className="w-full border-t-2 border-primary border-solid bg-white p-2 shadow h-16 flex items-center">
        <div className="flex flex-col space-y-2 w-full text-center">
          <div className=" w-full">Actions</div>
        </div>
      </div>
      <table>
        {generateHeader(["s"])}
        <tbody>
          {moves.map((move, index) => (
            <tr key={index}>
              <td className="flex items-center">
                <button
                  type="button"
                  onClick={() => {
                    handleDuplicateStep(index);
                  }}
                >
                  <MsxIcons name="duplicate" className="text-secondary" />
                </button>
                <button
                  type="button"
                  onClick={() => {
                    handleDeleteStep(index);
                  }}
                >
                  <MsxIcons
                    name="action_remove_flat"
                    className="text-red-600"
                  />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div> */}
          </div>
          {/* <Button secondary large classes="w-fit h-7" onClick={handleAddStep}>
      Add step
    </Button> */}
          {/* END TABLE */}
          <div>
            <qds-button
              data-testid="button-add-step"
              size="small"
              text={t("cartesian.ui.dynamics.add_step")}
              importance="emphasized"
              onClick={() => {
                handleAddNewMove();
              }}
              {...(dynamics.steps.length >= 4 ? { disabled: "" } : {})}
              icon-name="plus-large"
            />
          </div>
        </div>
        {/* <div className="flex">
      <pre className="flex-1">
        {JSON.stringify(generateMovesData(moves), null, 2)}
      </pre>
      <pre className="flex-1">{JSON.stringify(moves, null, 2)}</pre>
    </div> */}
      </div>
    </>
  );
};

export default CycleDefinition;
